import layout from './TableConfigView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';
import TableConfigViewModel from '@/ViewModels/Views/TableConfigViewModel';

export default class TableConfigView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(private viewModel: TableConfigViewModel, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        this.defineSubscription(this.viewModel.scrollObservable, (scrollIndex) => {
            this.async(() => {
                let $tbody = this.view.find('.left').find('tbody');
                let children = $tbody.children();
                if (children.length > 0) {
                    let childToScrollTo = scrollIndex < children.length ? children[scrollIndex] : children[children.length - 1];
                    $(childToScrollTo).scrollParent().scrollTop(27 * (scrollIndex - 3));
                }
            }, 1);
        });

        return this.view;
    }
}

ComponentManager.setView('TableConfigView', TableConfigView, 'RADPresentation.HTMLClient.DefaultViewExtensions');